import gql from 'graphql-tag';

const ADD_OTA = gql`
  mutation createOTA(
    $firmwareVersion: String
    $hardwareVersion: Int
    $deviceType: [String]
    $url: String
    $crc: String
  ) {
    createOTA(
      firmwareVersion: $firmwareVersion
      hardwareVersion: $hardwareVersion
      deviceType: $deviceType
      url: $url
      crc: $crc
    ) {
      code
    }
  }
`;

export default ADD_OTA;
